import React, { useMemo } from 'react'
import { isEmail } from 'validator'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

import { useAuth } from '@sputnik/auth'
import { type Collaborator } from '@sputnik/hooks/useApplicationCollaborators'

export interface UseInviteCollaboratorsSchemaParams {
  collaborators: Collaborator[]
}

export const useInviteCollaboratorsSchema = ({ collaborators }: UseInviteCollaboratorsSchemaParams) => {
  const { email } = useAuth()

  const schema = useMemo(
    () =>
      yup.object().shape({
        emails: yup
          .string()
          .test(
            'isEmailList',
            () => (
              <FormattedMessage
                defaultMessage='Enter only valid email addresses separated by commas'
                id='sputnik.InviteCollaboratorsDrawer__uqgaRD'
              />
            ),
            (value) => {
              if (!value) {
                return true
              }

              const emailEntries = value.split(',')
              if (emailEntries.some((email) => !isEmail(email.trim()))) {
                return false
              }

              return true
            },
          )
          .test(
            'areNewEmails',
            () => (
              <FormattedMessage
                defaultMessage='One or more entered email(s) is already a collaborator'
                id='sputnik.InviteCollaboratorsDrawer__Vcg+hN'
              />
            ),
            (value) => {
              if (!value) {
                return true
              }
              const emailEntries = value.split(',')

              if (emailEntries.includes(email ?? '')) {
                return false
              }

              return !collaborators.some(({ email }) => emailEntries.includes(email.trim().toLowerCase()))
            },
          )
          .required(),
      }),
    [collaborators, email],
  )

  return schema
}
